//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class RoleListModel extends ModelBase {
      static readonly $typeName = 'RoleListModel';
      public key: string;
      public name: string;
      public type: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/RoleListModel.ts